import { render, staticRenderFns } from "./PInput.vue?vue&type=template&id=51a67f3a&scoped=true&"
import script from "./PInput.vue?vue&type=script&lang=ts&"
export * from "./PInput.vue?vue&type=script&lang=ts&"
import style0 from "./PInput.vue?vue&type=style&index=0&id=51a67f3a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51a67f3a",
  null
  
)

export default component.exports